import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import CreateFormInput from '../CreateFormInput';
import { colors } from '../../Utils/Colors';
import { serverUrls } from '../../Utils/Urls';
import { getDexa3, getDexa3Failure, getDexa3Success,resetDexa3State } from '../../Actions/patientAction';
import { connect } from 'react-redux';
import axios from 'axios';

const formInputs = {
    lumberSpine3: {
        type: 'text',
        label: 'Lumber Spine'
    },
    leftHip3: {
        type: 'text',
        label: 'Left Hip'
    },
    rightHip3: {
        type: 'text',
        label: 'Right hip'
    },
    neck3: {
        type: 'text',
        label: 'Neck'
    },
    radius_ulna3: {
        type: 'text',
        label: 'Radius/ulna'
    },   
}

class Dexa3 extends React.Component {

    componentDidMount() {
        this.props.getDexa3Edit(serverUrls.dexa3 + this.props.id + '/');
    }
    componentWillUnmount() {
        this.props.resetDexa3State();
      }

    render() {
        var url = serverUrls.dexa3 + this.props.id + '/';
        return (
            <Container style={{maxWidth: 800, background: colors.lightGrey}}>
                <br/>
                <h4>Dexa after 3 year</h4>
                <br/>
                <Row>
                    <Col sm={{size: 12}}>
                        <Row>
                            <Col sm={2}>
                                <h6>Region</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>BMD</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>BMC</h6>
                            </Col>
                            <Col sm={3}>
                                <h6>T Score</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>Z score</h6>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <CreateFormInput size={3} label={false} count={4} isPost={false} buttonName="Save" url={url} formName="getDexa3" inputs={formInputs} />
                <br/>
                <br/>
            </Container>
        )
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        getDexa3Edit: (url) => {
            dispatch(getDexa3({loading: true}));
            axios.get(url).then((res)=>{
                dispatch(getDexa3Success({loading: false, success: res.data.success, data: res.data}));
            }).catch((err)=>{
                dispatch(getDexa3Failure({loading: false}));
            });
        },
        resetDexa3State: () => {
            dispatch(resetDexa3State());
          },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dexa3);
